// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__22KoG","inputWrap":"Table_inputWrap__21x58","col":"Table_col__1l6bt","bmiTooltip":"Table_bmiTooltip__2VhaK"};